var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 95,
    viewBox: "0 0 114 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 30L98.1025 44.1652H112.997L100.947 52.9197L105.55 67.0848L93.5 58.3303L81.4504 67.0848L86.0529 52.9197L74.0033 44.1652H88.8975L93.5 30Z",
    fill: "#E6889F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9601 11.2076L51.7779 33.5391L77.9044 25.3964L61.5538 47.3408L77.3716 69.6724L51.4486 60.9032L35.098 82.8476L35.4273 55.4836L9.50426 46.7144L35.6308 38.5717L35.9601 11.2076Z",
    fill: "#445597"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars2);
export default __webpack_public_path__ + "static/media/stars-2.cce087e351f0f91f791307043fd60af6.svg";
export { ForwardRef as ReactComponent };